import React, { useState, useEffect } from "react";
import { Modal, Select, Input, Form, Button } from "antd";
import { GreenNotify, RedNotify } from "../../helper/helper";
import routes from "../../api/routes";
import configureAppStore from "../../redux/store";
import { callApi } from "../../api/apiCaller";
import CompoundedSpace from "antd/es/space";

const AddVideo = ({ visible, toggleModal, recordData }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const getAllclients = async () => {
    let getRes = (res) => {
      console.log("Response received by clients.....", res);
      setClients(res?.data?.users);
    };

    const result = await callApi(
      "GET",
      `${routes.getUsers}?role=Client`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error,,", error);
      }
    );
  };

  useEffect(() => {
    getAllclients();
  }, []);
  useEffect(() => {
    if (visible) {
      if (recordData) {
        form.setFieldsValue({
          clientId: recordData.clientId._id,
          number: recordData.number,
        });
      } else {
        form.resetFields();
      }
    }
  }, [visible, recordData]);

  const token = configureAppStore.getState().userDataSlice.token;
  const handleSave = () => {
    console.log("Form values before validation:", form.getFieldsValue());

    form
      .validateFields()
      .then((values) => {
        console.log("Validated values:", values);
        const requestBody = {
          clientId: values.clientId, // Get from form values, not recordData
          number: values.number,
        };

        console.log("Final Request Body:", requestBody);

        const getRes = (res) => {
          if (res.status === 400) {
            RedNotify("Validation Error: " + res.message);
          } else if (res.status === 200) {
            GreenNotify(
              recordData
                ? "Number updated successfully."
                : "Number created successfully."
            );
            toggleModal();
          } else {
            RedNotify("An error occurred. Please try again later.");
          }
        };

        callApi(
          recordData ? "PATCH" : "POST",
          recordData
            ? `${routes.updateNumber}/${recordData._id}`
            : `${routes.createNumber}`,
          requestBody,
          setIsLoading,
          getRes,
          (error) => {
            console.error("API call error", error);
            RedNotify("An error occurred. Please try again later.");
          }
        );
      })
      .catch((errorInfo) => {
        console.error("Validation Error:", errorInfo);
        RedNotify("Please ensure all fields are filled out correctly.");
      });
  };

  return (
    <Modal
      title={recordData ? "Update Number" : "Create Number"}
      visible={visible}
      onCancel={toggleModal}
      footer={[
        <Button key="cancel" onClick={toggleModal}>
          Cancel
        </Button>,
        <Button
          key="save"
          type="primary"
          onClick={handleSave}
          loading={isLoading}
          disabled={isLoading}
        >
          {recordData ? "Update" : "Save"}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="clientId"
          label="Client"
          rules={[{ required: true, message: "Please select a client" }]}
        >
          <Select
            placeholder="Select Client"
            optionFilterProp="children"
            showSearch
          >
            {clients.map((client) => (
              <Select.Option key={client._id} value={client._id}>
                {client.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Number"
          name="number"
          rules={[{ required: true, message: "Please enter number" }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddVideo;
